import { render, staticRenderFns } from "./BikeparkFormDataTable.vue?vue&type=template&id=da8e1b06&"
import script from "./BikeparkFormDataTable.vue?vue&type=script&lang=js&"
export * from "./BikeparkFormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports